import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AppSettings } from '../providers/app-settings';

@Injectable()
export class LoginService {

  private apiUrl: string;

  constructor(public http: Http, private appSettings: AppSettings) {
    this.apiUrl = this.appSettings.DB_API_ENDPOINT;
  }

  public login(username, password): Observable<any> {
    return this.http.post(this.apiUrl + 'users/login', { username, password }, this.appSettings.apiOptions);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/login.service.ts